import React from "react";
import classes from "./VsRatingBar.module.css";
import pb00 from "../../../assets/Game/bars/pb00.png";
import pb05 from "../../../assets/Game/bars/pb05.png";
import pb10 from "../../../assets/Game/bars/pb10.png";
import pb15 from "../../../assets/Game/bars/pb15.png";
import pb20 from "../../../assets/Game/bars/pb20.png";
import pb25 from "../../../assets/Game/bars/pb25.png";
import pb30 from "../../../assets/Game/bars/pb30.png";
import pb35 from "../../../assets/Game/bars/pb35.png";
import pb40 from "../../../assets/Game/bars/pb40.png";
import pb45 from "../../../assets/Game/bars/pb45.png";
import pb50 from "../../../assets/Game/bars/pb50.png";
import pb55 from "../../../assets/Game/bars/pb55.png";
import pb60 from "../../../assets/Game/bars/pb60.png";
import pb65 from "../../../assets/Game/bars/pb65.png";
import pb70 from "../../../assets/Game/bars/pb70.png";
import pb75 from "../../../assets/Game/bars/pb75.png";
import pb80 from "../../../assets/Game/bars/pb80.png";

type VsRatingTypes = {
  name: String;
  rating?: Number;
};

const VsRatingBar:React.FC<VsRatingTypes> = ({name, rating}) => {
// @ts-ignore
const score =  Math.ceil(rating/5)*5;

let img = ""
switch (score) {
  case 0:
    img = pb00
    break;
  case 5:
    img = pb05
    break;
  case 10:
    img = pb10
    break;
  case 15:
    img = pb15
    break;
  case 20:
    img = pb20
    break;
  case 25:
    img = pb25
    break;
  case 30:
    img = pb30
    break;
  case 35:
    img = pb35
    break;
  case 40:
    img = pb40
    break;
  case 45:
    img = pb45
    break;
  case 50:
    img = pb50
    break;
  case 55:
    img = pb55
    break;
  case 60:
    img = pb60
    break;
  case 65:
    img = pb65
    break;
  case 70:
    img = pb70
    break;
  case 75:
    img = pb75
    break;
  case 80:
    img = pb80
    break;

  default:
    img = pb00
    break;
}

return (
  <div className={classes["strength-root"]}>
      <div className={classes["strength-title"]}>{name}</div>
      <img className={classes["strength-img"]} src={img} alt="" />
  </div>
)
}

export default VsRatingBar
